import * as React from "react";
import { withStyles } from "src/decorators";
import { isIFrame, isWebView } from "src/helpers";
import styled, { css } from "styled-components";
import { MediaQueries } from "src/constants";
import { useWindow } from "src/hooks";

interface Props extends React.HTMLProps<HTMLDivElement> {
  withNavbar?: boolean;
  wrapHeight?: boolean;
  wrapHeightInWebView?: boolean;
  wrapWidth?: boolean;
  center?: boolean;
}

const ContainerEl = styled.div<{ height: number } & Props>`
  box-sizing: border-box;
  padding: 16px 24px 32px;
  flex-shrink: 0;
  width: 100%;

  ${(props) =>
    props.center &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
    `}

  ${MediaQueries.screen.medium.maxWidth} {
    padding: 16px;
  }

  ${(p) =>
    p.withNavbar &&
    isWebView() &&
    css`
      // screen height minus height of navbar on mobile + padding from container
      height: calc(${p.height}px - (56px + 16px));
    `}

  ${(p) =>
    (p.wrapHeight || (p.wrapHeightInWebView && isWebView())) &&
    css`
      display: flex;
      flex: auto;
      flex-direction: column;
    `}
  
  ${(p) =>
    p.wrapWidth &&
    css`
      max-width: 731px;
    `}

  ${isIFrame() &&
  css`
    padding: 8px;

    ${MediaQueries.screen.medium.maxWidth} {
      padding: 16px 8px;
    }
  `}
`;

export const Container = withStyles(({ children, ...other }: Props) => {
  const { innerHeight } = useWindow();

  return (
    <ContainerEl height={innerHeight} {...(other as any)}>
      {children}
    </ContainerEl>
  );
});
